import { Component, HostBinding } from "@angular/core";

@Component({
    selector: "sps-description-list-definition, sps-dd",
    templateUrl: "./sps-description-list-definition.component.html"
})
export class SpsDescriptionListDefinitionComponent {
    static readonly displayName = "sps-description-list-definition / sps-dd";
    static readonly props = {};

    @HostBinding("class.sps-description-list__definition") readonly _spsDescriptionListDefinitionClass = true;
    @HostBinding("style.msGridRow") rowIndex = 0;
}
